import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css'],
  standalone: false,
})
export class SummaryComponent implements OnInit, OnDestroy {
  public result: any = {};
  private currentUrl: string;
  public timeoutId: any;
  private routerSubs: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
  ) {
    this.activatedRoute.params.subscribe(params => {
      const resultInfo = JSON.parse(params.result.toString());
      this.result.orderIds = resultInfo.ordersIds;
      this.result.message = resultInfo.message;
    });

    this.routerSubs = this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });

    this.timeoutId = setTimeout(() => {
      if (!this.currentUrl || this.currentUrl.includes('summary')) {
        this.router.navigate(['secure/order-list']);
      }
    }, 5000);
  }

  ngOnInit() {
    this.determineMessage();
  }

  determineMessage(): void {
    if (!!this.result.orderIds) {
      this.translateService
        .get(this.result.message, { value: this.result.orderIds })
        .subscribe(res => {
          this.result.messageText = res;
        });
    } else {
      this.translateService.get(this.result.message).subscribe(res => {
        this.result.messageText = res;
      });
    }
  }

  ngOnDestroy(): void {
    this.routerSubs.unsubscribe();
    clearTimeout(this.timeoutId);
  }
}
